import { ContactResource, ContactTypes } from "../../js/classes/Api/Contact";
import { reactive } from "vue";
const state = reactive({
    isLoading: false,
    contacts: undefined
});
let request;
export default function useFinanceProviderStore() {
    async function getFinanceProviders() {
        if (state.contacts !== undefined) {
            return state.contacts;
        }
        if (request === undefined) {
            state.isLoading = true;
            request = ContactResource.all({ type: ContactTypes.FINANCE_PROVIDER, limit: 200 }).then((response) => {
                state.contacts = response.data.results;
                return state.contacts;
            }).finally(() => {
                state.isLoading = false;
                request = undefined;
            });
        }
        return request;
    }
    getFinanceProviders();
    return {
        state,
        getFinanceProviders
    };
}
